import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { useQuery } from '../../../common/useQuery'
import { AppState } from '../../../store'
import { recreateCredentials } from '../../../store/middleware/credential.action'
import useAppInitLogic from '../../../hooks/useAppInitLogic'
import { APP_INIT_TYPES } from '../../../hooks/HooksProps'
import analyticsService from '../../../service/analytics.service'
import { SET_APP_HAS_ERROR } from '../../../store/actions/application-actions'


/**
  * Custom hook obsługujący logikę strony powrotu z banku po poprawnej weryfikacji
  * @returns 
*/
const useBankVerificationSuccessPageLogic = () => {
   const query = useQuery()
   const history = useHistory()
   const dispatch = useDispatch()
   const { getAppConfiguration } = useAppInitLogic(APP_INIT_TYPES.BANK_VERIFICATION_RETURN)
   const [isTextContentsLoaded, setIsTextContentsLoaded] = useState(false)
   const ANALYTICS_EVENT_TYPES_NAMES = useSelector((state: AppState) => state.lenConfigState.analyticsEventTypesNames)


   useEffect(() => {
       (async () => {// Inicjalizacja tekstów na stronę oraz pobieranie konfiguracji projektu. Zapis danych do state'a
         try {
            await getAppConfiguration()
            setIsTextContentsLoaded(true)
         }
         catch (e: any) {
            const ERROR_ANALYTICS_DATA = {
               id: analyticsService.DISPLAY_ERROR_PAGE_IDS.BANK_VERIFICATION_SUCCESS_PAGE_ERROR,
               reason: "Nie udało się pobrać konfiguracji aplikacji po poprawnym powrocie z klienta banku.",
               details: { }
            }
            
            dispatch({ type: SET_APP_HAS_ERROR }) //Ustawiamy globalny błąd aplikacji co spowoduje przejście na ekran z błędem
            await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.FrontendErrorPageDisplayed, JSON.stringify(ERROR_ANALYTICS_DATA, undefined, 3))

            return
         }
       })()
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []) 

   useEffect(()=> { //Dopiero gdy teksty zostaną załadowane uruchamiamy proces dalej
     if(isTextContentsLoaded){
       const queryId = query.get("orderUuid") as string;

       dispatch(recreateCredentials(queryId))
       history.push('/bm-waiting');
     }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [ isTextContentsLoaded ])
}

export default useBankVerificationSuccessPageLogic;